import MedTestLightLogo from "../Components/Icons/medtest-light-logo.svg";
import MedTestDarkLogo from "../Components/Icons/medtest-dark-logo.svg";
import LifeStyleLightLogo from "../Components/Icons/life-style-light.svg";
import LifeStyleDarkLogo from "../Components/Icons/life-style-dark.svg";
import LegalLightLogo from "../Components/Icons/legal-logo-light.svg";
import LegalDarkLogo from "../Components/Icons/legal-dark.svg";
import medTestFavicon from "../favicons/med-favicon.png";
import LifeStyleFavicon from "../favicons/life-style-favicon.png";
import LTKFavIcon from "../favicons/lamtakam-favicon.png";
import LegalFavIcon from "../favicons/legal-favicon.png";
import MedicalLoading from "../Components/AnimatedLoadings/medical.gif";
import LifeStyleLoading from "../Components/AnimatedLoadings/lifestyle.gif";
import LegalLoading from "../Components/AnimatedLoadings/legal.gif";
import progressDotsDark from "../Components/AnimatedLoadings/progress-dots.gif";
import progressDotsLight from "../Components/AnimatedLoadings/progress-dots-white.gif";
import MedicalBotVector from "../Components/Icons/bot-medical.svg";
import LifeStyleBotVector from "../Components/Icons/bot-lifestyle.svg";
import LegalBotVector from "../Components/Icons/bot-legal.svg";
import LTKLight from "../Components/Icons/ltk-light.svg";
import LTKDark from "../Components/Icons/ltk-dark.svg";

const config = {
  "lamtakam.com": {
    botVector: MedicalBotVector,
    progressLoading: {
      dark: progressDotsDark,
      light: progressDotsLight,
    },
    favicon: LTKFavIcon,
    animatedLoading: {
      dark: MedicalLoading,
      light: MedicalLoading,
    },
    logo: {
      light: LTKLight,
      dark: LTKDark,
    },
    colors: {
      light: {
        primary: "#478DF5",
      },
      dark: {
        primary: "#478DF5",
      },
    },
  },
  "medical.lamtakam.com": {
    botVector: MedicalBotVector,
    favicon: medTestFavicon,
    progressLoading: {
      dark: progressDotsDark,
      light: progressDotsLight,
    },
    animatedLoading: {
      dark: MedicalLoading,
      light: MedicalLoading,
    },
    logo: {
      light: MedTestLightLogo,
      dark: MedTestDarkLogo,
    },
    colors: {
      light: {
        primary: "#068D93",
      },
      dark: {
        primary: "#068D93",
      },
    },
  },
  "legal.lamtakam.com": {
    botVector: LegalBotVector,
    favicon: LegalFavIcon,
    progressLoading: {
      dark: progressDotsDark,
      light: progressDotsLight,
    },
    animatedLoading: {
      dark: LegalLoading,
      light: LegalLoading,
    },
    logo: {
      light: LegalLightLogo,
      dark: LegalDarkLogo,
    },
    colors: {
      light: {
        primary: "#212142",
      },
      dark: {
        primary: "#212142",
      },
    },
  },
  "lifestyle.lamtakam.com": {
    botVector: LifeStyleBotVector,
    favicon: LifeStyleFavicon,
    progressLoading: {
      dark: progressDotsDark,
      light: progressDotsLight,
    },
    animatedLoading: {
      dark: LifeStyleLoading,
      light: LifeStyleLoading,
    },
    logo: {
      light: LifeStyleLightLogo,
      dark: LifeStyleDarkLogo,
    },
    colors: {
      light: {
        primary: "#C11446",
      },
      dark: {
        primary: "#C11446",
      },
    },
  },
  localhost: {
    botVector: MedicalBotVector,
    progressLoading: {
      dark: progressDotsDark,
      light: progressDotsLight,
    },
    favicon: LTKFavIcon,
    animatedLoading: {
      dark: MedicalLoading,
      light: MedicalLoading,
    },
    logo: {
      light: LTKLight,
      dark: LTKDark,
    },
    colors: {
      light: {
        primary: "#478DF5",
      },
      dark: {
        primary: "#478DF5",
      },
    },
  },
};

const currentHost = window.location.hostname;

// @ts-ignore
const settings = config[currentHost] || {};

export default settings;
